<template>
	<div>
		<Modal
			:show="showViewLoan"
			content_class="col-12 col-md-10 col-lg-8 col-xl-7 view-loan"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">Loan Details</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showViewLoan', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="content" v-if="loan_details">
						<div class="col-12">
							<div class="card card-details">
								<div class="top">
									<div class="clearfix">
										<div
											class="f-l status tx-green"
											:class="{
												'tx-yellow':
													loan_details.status !==
													'initiated',
											}"
										>
											{{ loan_details.status }}
										</div>
									</div>
									<div class="icon-box">
										<div class="clearfix">
											<div
												v-if="loan_details.loan_product"
											>
												<div class="f-l">
													<img
														:src="
															loan_details
																.loan_product
																.loan_product_img_path
														"
														alt=""
														class="logo"
													/>
												</div>
												<div class="f-l txt-box">
													<div class="product">
														{{
															loan_details
																.loan_product
																.loan_product_name
														}}
													</div>
													<div class="bank">
														{{
															loan_details
																.loan_product
																.loan_product_description
														}}
													</div>
												</div>
											</div>

											<Dropdown
												class="fx-dropdown f-r"
												trigger="click"
												@on-click="clickAction($event)"
											>
												<div class="btn btn-red btn-sm">
													<i class="fa fa-wrench"></i>
													Actions
													<i
														class="fa fa-chevron-down"
													></i>
												</div>
												<DropdownMenu slot="list">
													<!-- <DropdownItem name="view_invoice" v-if="loan_details.application_type === 'school'">
                                             <div class="clearfix">
                                             <i class="fa fa-credit-card"></i> 
                                             <div class="menu-text">View Invoice</div> 
                                             </div>
                                       </DropdownItem> -->
													<DropdownItem
														name="view_loan"
														v-if="
															loan_details
																.disbursement
																.status ===
															'disbursed'
														"
													>
														<div class="clearfix">
															<i
																class="fa fa-receipt"
															></i>
															<div
																class="menu-text"
															>
																View Loan
															</div>
														</div>
													</DropdownItem>
													<DropdownItem
														name="view_wallet"
													>
														<div class="clearfix">
															<i
																class="fa fa-wallet"
															></i>
															<div
																class="menu-text"
															>
																View Wallet
															</div>
														</div>
													</DropdownItem>
												</DropdownMenu>
											</Dropdown>
										</div>
									</div>
									<div class="detail-box">
										<div class="ref">
											Loan Ref:
											<b>{{
												loan_details.application_system_ref.toUpperCase()
											}}</b>
										</div>
										<div class="payment">
											Loan Amount:
											{{
												loan_details.application_currency
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														loan_details.application_amount *
															100,
													) / 100,
												)
											}}
										</div>
										<div class="payment">
											Approved Amount:
											{{
												loan_details.application_currency
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														loan_details.approved_amount *
															100,
													) / 100,
												)
											}}
										</div>
										<div class="payment">
											Upfront Payment Amount:
											{{
												loan_details.application_currency
											}}
											{{
												utils.numberWithCommas(
													Math.round(
														loan_details.loan_upfront_payment_amount *
															100,
													) / 100,
												)
											}}
										</div>
										<div class="payment">
											Loan Period:
											{{
												loan_details.application_loan_term
											}}
										</div>
										<div class="payment">
											Application Type:
											{{ loan_details.application_type }}
										</div>
										<div class="stage mb-3">
											Application Stage:
											<b>{{
												loan_details.application_status
											}}</b>
										</div>

										<hr />
										<div class="ref">
											Invoice Ref:
											<b>{{
												loan_details.invoice_system_ref.toUpperCase()
											}}</b>
										</div>
										<div class="stage">
											Invoice Stage:
											<b>{{
												loan_details.disbursement.status
											}}</b>
										</div>
										<div
											class="payment"
											v-if="
												loan_details.disbursement
													.status !== 'disbursed'
											"
										>
											Expected Disbursement Date:
											{{
												moment(
													loan_details.disbursement
														.expected_disb_date,
												).format('Do MMM YYYY')
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<AddReview />
		<ShowReviews title="Loan Product Reviews" />
	</div>
</template>

<script>
export default {
	components: {
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		AddReview: () => import('../templates/others/review'),
		ShowReviews: () => import('../templates/others/list-reviews'),
	},
	computed: {
		...mapGetters([
			'loading',
			'school_loan_details_table',
			'loan_details',
			'showViewLoan',
			'loan_transactions',
			'loan_notifications',
			'loan_account_details',
			'LoanModel',
			'activeTabLoan',
			'loan_payment_schedules',
		]),
	},
	data() {
		return {
			utils,
			moment,
			api,
			activeTab: 1,
		};
	},
	methods: {
		...mapActions([
			'requestIPF',
			'payLoan',
			'openTabLoan',
			'fetchIPFReviews',
			'fetchTopupOptionsUpdate',
			'fetchProductReviews',
		]),
		async clickAction(action) {
			switch (action) {
				case 'view_wallet':
					this.$router.push({ name: 'Accounts' });
					break;
				case 'view_loan':
					await $session.set(
						'selected_loan_page',
						this.loan_details.disbursement.loan_account_number,
					);
					this.$router.push({ name: 'My_Loans' });
					break;
				case 'view_invoice':
					await $session.set(
						'selected_invoice_page',
						this.loan_details.invoice_system_ref,
					);
					this.$router.push({ name: 'School_Fees_Invoice' });
					break;
				default:
					break;
			}
		},
		getOutstandingAmount(s) {
			let due =
				s.paymentToPrinciple +
				s.paymentToInterest +
				s.feesDue +
				s.penaltiesDue;
			let payment =
				s.principalPayment +
				s.interestPayment +
				s.feePayment +
				s.penaltyPayment;

			return utils.numberWithCommas(
				Math.round(Math.abs(due - payment) * 100) / 100,
			);
		},
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-loan {
	.schedule {
		.amount {
			text-align: right;
		}
	}
	.status {
		font-size: 12px;
		text-transform: uppercase;
		font-weight: 600;

		&.tx-yellow {
			color: var(--ne-yellow);
		}
	}
	.detail-box {
		margin: 30px 0 0 0;

		.payment {
			margin: 2px 0;
			font-size: 14px;

			.overdue {
				color: var(--ne-blue);
			}
		}
		.stage {
			font-size: 13px;

			b {
				color: #9c7bfc;
			}
		}
	}
	.notification {
		padding: 22px 0;
		border-bottom: solid 1px #f5f9fb;
		cursor: pointer;

		.content-box {
			width: calc(100% - 65px);

			.title {
				color: #3d4661;
				font-weight: 600;
				font-size: 16px;
			}
			.txt {
				color: #646f79;
				font-size: 14px;
			}
			.date {
				color: #646f79;
				font-size: 13px;
				font-weight: 600;
			}
		}
	}
	.card.details-card {
		padding: 10px;

		.title {
			font-size: 13px;
			font-weight: 600;
			text-transform: uppercase;
			margin: 0 0 10px 0;

			&.total {
				padding: -7px 0 7px 0;
				margin: -10px 0 5px -10px;
				border-bottom: solid 1px var(--border-grey);
			}
		}
		.th {
			font-size: 12px;
		}
		.tr {
			font-size: 13px;
			font-weight: 600;
			text-align: right;
		}
	}
	.insurance {
		font-weight: 600;
		font-size: 16px;
		margin: 0 0 30px 0;
	}
	.icon-box {
		.txt-box {
			margin: 20px 0 0 0;
		}
		.logo {
			width: 80px;
			height: auto;
			min-height: 20px;
			margin: 10px 10px 0 0;
		}
		.bank {
			font-size: 13px;
			font-weight: 600;
			color: var(--primary);
		}

		.product {
			color: @grey;
			font-weight: 600;
		}
	}
	.ref {
		font-size: 13px;
	}
	.empty {
		text-align: center;
		padding: 40px 0;
		font-size: 13px;
		color: var(--ne-red);
	}
	.payment {
		font-size: 14px;
		font-weight: 600;

		b {
			color: var(--primary) !important;
		}
	}
	.status {
		color: var(--ne-green);
		font-size: 14px;
		font-weight: 600;
	}

	.transactions {
		margin: 30px -30px 20px -30px;
	}
}
</style>
